const CONST = require('plugin_frontend_core/constants');
const formValidation = require('./formValidation');

const selectors = {
    wishlistModal: '.js-wishlist-modal',
    wishlistModalSize: '.js-wishlist-modal-size',
    wishlistModalSubmit: '.js-wishlist-modal-submit',
    wishlistModalForm: '.js-wishlist-modal form.login'
};

/**
* handleSizeChange
* @param {event} event - The event
*/
function handleSizeChange(event) {
    event.preventDefault();
    $(selectors.wishlistModalSize).removeClass(CONST.classes.error);
}

/**
* handleSubmit
* @param {event} event - The event
*/
function handleSubmit(event) {
    event.preventDefault();

    const $selectedSize = $(selectors.wishlistModalSize);

    if (!$selectedSize.val()) {
        $selectedSize.addClass(CONST.classes.error);
        return;
    }

    $(selectors.wishlistModal).trigger(CONST.events.wishlistModalCallback, $selectedSize.val()).modal('hide');
}

/**
* handleLogin
* @param {event} event - The event
*/
function handleLogin(event) {
    event.preventDefault();

    const $selectedSize = $(selectors.wishlistModalSize);
    const $form = $(event.currentTarget);

    $form.find('.alert').remove();

    if (!$selectedSize.val()) {
        $selectedSize.addClass(CONST.classes.error);
        return;
    }

    const postUrl = $form.attr(CONST.attributes.action);
    const formData = $form.serialize();

    $form.spinner().start();

    $.ajax({
        url: postUrl,
        type: 'post',
        dataType: 'json',
        data: formData,
        success: function (data) {
            if (data.success) {
                $(selectors.wishlistModal).trigger(CONST.events.wishlistModalCallback, $selectedSize.val());
            } else {
                formValidation($form, data);
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }
        },
        complete: function () {
            $form.spinner().stop();
        }
    });
}

/**
 * Handle add to wish list button click
 */
function clickAddToWishlistHandler() {
    var $form = $(selectors.wishlistModalForm);
    $form.find('.alert.alert-danger').remove();
    $form.find('[id^=login-form-email]').val('');
    $form.find('[id^=login-form-password]').val('');
}

/**
* Initializes the file
*/
function init() {
    $(document).on(CONST.events.submit, selectors.wishlistModalForm, handleLogin);
    $(document).on(CONST.events.click, selectors.wishlistModalSubmit, handleSubmit);
    $(document).on(CONST.events.change, selectors.wishlistModalSize, handleSizeChange);
    window.pubSub.subscribe(CONST.pubSubEvents.wishlist.clickAddToWishlist, clickAddToWishlistHandler);
}

module.exports = {
    init: init
};
